<template>
  <div class="top-side-view-container">
    <svg-with-padding
      :width="720"
      :height="480"
      padding="0"
      v-slot="contentBox"
      preserveAspectRatio="xMidYMin meet"
    >
      <top-side-view
        v-if="geojson"
        v-bind="contentBox"
        :padding="20"
        :bbox="bbox"
        :data="geojson.features"
        :h="(f) => f.properties.height || 0"
        :year="year"
      >
      </top-side-view>
      <g class="vg-annotation" v-if="year === 2021">
        <text class="vg-annotation__year" transform="translate(73.05 57.11)"
          >1973</text
        >
        <text class="vg-annotation__building" transform="translate(73.05 80.23)"
          >Block 175</text
        >
        <text class="vg-annotation__year" transform="translate(516.39 336.9)"
          >2020</text
        >
        <text
          class="vg-annotation__building"
          transform="translate(516.4 360.02)"
          >Block 102B</text
        >
        <g>
          <path d="M106,89v124Z" />
          <circle cx="106" cy="220" r="7" />
        </g>
        <g>
          <path d="M533,218v95Z" />
          <circle cx="533" cy="211" r="7" />
        </g>
      </g>
      <synced-timer v-model="year"></synced-timer>
    </svg-with-padding>
  </div>
</template>

<script>
import TopSideView from './TopSideView.vue'
import SyncedTimer from './SyncedTimer.vue'
import SvgWithPadding from 'vue-graphics/hocs/SvgWithPadding'
import geodata from '../../../../assets/data/hdb2021.json'

export default {
  components: {TopSideView, SyncedTimer, SvgWithPadding},
  props: ['attributes'],
  data () {
    return {
      geojson: null,
      year: 0
    }
  },
  computed: {
    bbox () {
      return [-0.03, -0.6667, 0, 1.03, 1, 1.2]
    }
  },
  created () {
    geodata.features.forEach((f, i) => {
      f.key = i
    })
    this.geojson = Object.freeze(geodata)
  }
}
</script>

<style lang="scss">
.top-side-view-container {
  max-width: 700px;

  svg {
    width: 100%;
    height: 100%;
  }

  .vg-annotation {
    opacity: 0;
    animation: fadein 0.4s ease-in 0.2s 1 normal forwards;

    @keyframes fadein {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    .vg-annotation__year {
      font-family: "CuratorBold", ui-sans-serif, system-ui, -apple-system,
        BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial,
        "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
        "Segoe UI Symbol", "Noto Color Emoji";
      font-weight: 700;
    }

    .vg-annotation__building {
      font-family: "CuratoRegular", ui-sans-serif, system-ui, -apple-system,
        BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial,
        "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
        "Segoe UI Symbol", "Noto Color Emoji";
    }

    circle,
    path {
      stroke: black;
      fill: none;
    }
  }
}
</style>
